import { openBlock as e, createElementBlock as t, createElementVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  d: "M5.333 1.25a.75.75 0 0 1 .75.75v.583h3.25a.75.75 0 0 1 0 1.5H8.286a12.784 12.784 0 0 1-1.792 4.315c.162.097.323.18.48.251a.75.75 0 0 1-.615 1.369 6.422 6.422 0 0 1-.767-.413 12.301 12.301 0 0 1-3.925 3.067A.75.75 0 1 1 1 11.328a10.807 10.807 0 0 0 3.4-2.637c-.74-.684-1.388-1.525-1.758-2.4a.75.75 0 0 1 1.382-.583c.254.601.716 1.228 1.278 1.771a11.253 11.253 0 0 0 1.445-3.396H1.333a.75.75 0 1 1 0-1.5h3.25V2a.75.75 0 0 1 .75-.75Zm5.196 4.88c.297-.143.644-.143.942 0 .262.127.402.347.468.457.07.117.14.265.208.406l.01.023 3.186 6.66a.75.75 0 1 1-1.353.648l-1.071-2.24H9.08l-1.071 2.24a.75.75 0 1 1-1.353-.648l3.185-6.66.011-.023c.067-.14.138-.289.208-.406.066-.11.206-.33.468-.457Zm-.73 4.453H12.2L11 8.072l-1.201 2.511Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  o
];
function n(r, d) {
  return e(), t("svg", l, [...c]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
